module.exports = __webpack_public_path__ + "img/nofriendbg.fae36b73.png";